module.exports = "/_next/static/images/blank-25a4d6eb5f4b341c5616fd0f6992baa8.png";